import { Box as MuiBox } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import osperb from 'assets/img/osperb/osperb25.png';
import { useLocale } from 'i18n';
import React, { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet';
import 'assets/styles/singleWork.css';
import 'assets/styles/slider.css';
import Router from 'routes/routes';
import useGeoRedirect from 'hooks/useGeoRedirect';
import ScrollToTop from './components/common/ScrollTop';
import theme from './theme';

const DefaultFooter = lazy(() => import('components/DefaultFooter'));

const App: React.FC = () => {
  const locale = useLocale();
  useGeoRedirect();
  const PreLoad: React.ReactElement = (
    <div className="h-screen w-100 flex items-center justify-center ">
      <MuiBox
        component="img"
        src={osperb}
        alt="Osperb Logo"
        sx={{
          width: '150px',
          height: 'auto',
          objectFit: 'contain',
        }}
      />
    </div>
  );

  return (
    <ThemeProvider theme={theme}>
      <Helmet htmlAttributes={{ lang: locale }} />
      <CssBaseline />
      <ScrollToTop />
      <Suspense fallback={PreLoad}>
        <Router />
      </Suspense>
      <Suspense fallback={null}>
        <DefaultFooter />
      </Suspense>
    </ThemeProvider>
  );
};

export default App;
